<div class="TabPanel {{ session.currentStyleMenuTabpanelReponsive }}">
  <div (click)="clickAreamenuToggledChange()" class="Tabs-container">
    <!-- Employees tabs -->
    <ng-container *ngIf="parentTab === 'employee'">
      <!-- Employee Open search -->
      <div class="TabPanel-item u-hideMobile" *ngIf="session.feature.ShowEmployeeList">
        <button class="TabPanel-link" type="button" (click)="session.employeeListActive = true">
          <div>
            <app-icon [icon]="'People'"></app-icon>
            <div class="TabPanel-title">
              {{ 'Employee.OpenSearch' | translate }}
            </div>
          </div>
        </button>
      </div>
      <!-- Employee General -->
      <div
        class="TabPanel-item"
        *ngIf="!session.role.EmployeeWithRoleAsManager"
        [ngClass]="{ 'is-active': state.currentStateIs('tabs.employee.general') }"
      >
        <button
          id="EmployeeGeneralTabButton"
          class="TabPanel-link"
          type="button"
          (click)="navigateToState($event, 'tabs.employee.general')"
          [ngClass]="{ 'is-active': state.currentStateIs('tabs.employee.general') }"
        >
          <div>
            <app-icon [icon]="'User'"></app-icon>
            <div class="TabPanel-title">
              {{ 'Employee.General' | translate }}
            </div>
          </div>
        </button>
        <div
          class="TabPanel-title-small-screen"
          [ngClass]="{ 'is-active': state.currentStateIs('tabs.employee.general') }"
        >
          {{ 'Employee.General' | translate }}
        </div>
      </div>
      <!-- Employee Employment -->
      <div
        class="TabPanel-item"
        *ngIf="!session.role.EmployeeWithRoleAsManager"
        [ngClass]="{ 'is-active': state.currentStateIs('tabs.employee.hiringstatus') }"
      >
        <button
          id="EmployeeHiringStatusTabButton"
          class="TabPanel-link"
          type="button"
          (click)="navigateToState($event, 'tabs.employee.hiringstatus')"
          [ngClass]="{ 'is-active': state.currentStateIs('tabs.employee.hiringstatus') }"
        >
          <div>
            <app-icon [icon]="'EditForm'"></app-icon>
            <div class="TabPanel-title">
              {{ 'Employee.Employment' | translate }}
            </div>
          </div>
        </button>
        <div
          class="TabPanel-title-small-screen"
          [ngClass]="{ 'is-active': state.currentStateIs('tabs.employee.hiringstatus') }"
        >
          {{ 'Employee.Employment' | translate }}
        </div>
      </div>
      <!-- Employee Time -->
      <div
        class="TabPanel-item"
        *ngIf="session.feature.EmployeeTimeTabEnabled"
        [ngClass]="{ 'is-active': state.currentStateIs('tabs.employee.time') }"
      >
        <button
          id="EmployeeTimeTabButton"
          class="TabPanel-link"
          type="button"
          (click)="navigateToState($event, 'tabs.employee.time')"
          [ngClass]="{ 'is-active': state.currentStateIs('tabs.employee.time') }"
        >
          <div>
            <app-icon [icon]="'Clock'"></app-icon>
            <div class="TabPanel-title">
              {{ 'Employee.Time' | translate }}
            </div>
          </div>
        </button>
        <div
          class="TabPanel-title-small-screen"
          [ngClass]="{ 'is-active': state.currentStateIs('tabs.employee.time') }"
        >
          {{ 'Employee.Time' | translate }}
        </div>
      </div>
      <!-- Employee Payroll Data -->
      <div
        class="TabPanel-item"
        *ngIf="session.feature.EmployeePayrollDataTabEnabled && !session.role.EmployeeWithRoleAsManager"
        [ngClass]="{ 'is-active': state.currentStateIs('tabs.employee.payrolldata') }"
      >
        <button
          id="EmployeePayrollDataTabButton"
          class="TabPanel-link"
          type="button"
          (click)="navigateToState($event, 'tabs.employee.payrolldata')"
          [ngClass]="{ 'is-active': state.currentStateIs('tabs.employee.payrolldata') }"
        >
          <div>
            <app-icon [icon]="'Table'"></app-icon>
            <div class="TabPanel-title">
              {{ 'Employee.PayrollData' | translate }}
            </div>
          </div>
        </button>
        <div
          class="TabPanel-title-small-screen"
          [ngClass]="{ 'is-active': state.currentStateIs('tabs.employee.payrolldata') }"
        >
          {{ 'Employee.PayrollData' | translate }}
        </div>
      </div>
      <!-- Employee Payslips -->
      <div
        class="TabPanel-item"
        *ngIf="!session.role.EmployeeWithRoleAsManager"
        [ngClass]="{ 'is-active': state.currentStateIs('tabs.employee.payslip') }"
      >
        <button
          id="EmployeePayslipTabButton"
          class="TabPanel-link"
          type="button"
          (click)="navigateToState($event, 'tabs.employee.payslip')"
          [ngClass]="{ 'is-active': state.currentStateIs('tabs.employee.payslip') }"
        >
          <div>
            <app-icon [icon]="'Dollar'"></app-icon>
            <div class="TabPanel-title">
              {{ 'EmployeeGeneral.Payslips' | translate }}
            </div>
          </div>
        </button>
        <div
          class="TabPanel-title-small-screen"
          [ngClass]="{ 'is-active': state.currentStateIs('tabs.employee.payslip') }"
        >
          {{ 'EmployeeGeneral.Payslips' | translate }}
        </div>
      </div>
    </ng-container>

    <!-- Company tabs -->
    <ng-container *ngIf="parentTab === 'company'">
      <!-- Company General -->
      <div
        class="TabPanel-item"
        *ngIf="!session.role.EmployeeWithRoleAsManager"
        [ngClass]="{ 'is-active': state.currentStateIs('tabs.company.general') }"
      >
        <button
          id="CompanyGeneralTabButton"
          class="TabPanel-link"
          type="button"
          (click)="navigateToStateNonWaitting($event, 'tabs.company.general')"
          [ngClass]="{ 'is-active': state.currentStateIs('tabs.company.general') }"
        >
          <div>
            <app-icon [icon]="'Industry'"></app-icon>
            <div class="TabPanel-title">
              {{ 'Company.General' | translate }}
            </div>
          </div>
        </button>

        <div
          class="TabPanel-title-small-screen"
          [ngClass]="{ 'is-active': state.currentStateIs('tabs.company.general') }"
        >
          {{ 'Company.General' | translate }}
        </div>
      </div>

      <!-- Company Payroll Data -->
      <div
        class="TabPanel-item"
        *ngIf="!session.role.EmployeeWithRoleAsManager && !IsMobile"
        [ngClass]="{ 'is-active': state.currentStateIs('tabs.company.payrolldata') }"
      >
        <button
          id="CompanyPayrollDataTabButton"
          class="TabPanel-link"
          type="button"
          (click)="navigateToStateNonWaitting($event, 'tabs.company.payrolldata')"
          [ngClass]="{ 'is-active': state.currentStateIs('tabs.company.payrolldata') }"
        >
          <div>
            <app-icon [icon]="'Table'"></app-icon>
            <div class="TabPanel-title">
              {{ 'Company.PayrollData' | translate }}
            </div>
          </div>
        </button>
        <div
          class="TabPanel-title-small-screen"
          [ngClass]="{ 'is-active': state.currentStateIs('tabs.company.payrolldata') }"
        >
          {{ 'Company.PayrollData' | translate }}
        </div>
      </div>
      <!-- Company Salary Batches -->
      <div
        class="TabPanel-item"
        *ngIf="!session.role.EmployeeWithRoleAsManager"
        [ngClass]="{ 'is-active': state.currentStateIs('tabs.company.salarybatches') }"
      >
        <button
          id="CompanySalaryBatchesTabButton"
          class="TabPanel-link"
          type="button"
          (click)="navigateToStateNonWaitting($event, 'tabs.company.salarybatches')"
          [ngClass]="{ 'is-active': state.currentStateIs('tabs.company.salarybatches') }"
        >
          <div>
            <app-icon [icon]="'Columns'"></app-icon>
            <div class="TabPanel-title">
              {{ 'Company.SalaryBatches' | translate }}
            </div>
          </div>
        </button>
        <div
          class="TabPanel-title-small-screen"
          [ngClass]="{ 'is-active': state.currentStateIs('tabs.company.salarybatches') }"
        >
          {{ 'Company.SalaryBatches' | translate }}
        </div>
      </div>

      <!-- Company Balances -->
      <div
        class="TabPanel-item"
        *ngIf="IsDanishCompany && !IsMobile && !session.role.IsEmployeeRole"
        [ngClass]="{ 'is-active': state.parentStateIs('tabs.company.balances') }"
      >
        <button
          id="CompanyBalancesTabButton"
          class="TabPanel-link"
          type="button"
          (click)="navigateToStateNonWaitting($event, 'tabs.company.balances')"
          [ngClass]="{ 'is-active': state.parentStateIs('tabs.company.balances') }"
        >
          <div>
            <app-icon [icon]="'balance-scale'"></app-icon>
            <div class="TabPanel-title">
              {{ 'ResidualVacation.Balances' | translate }}
            </div>
          </div>
        </button>

        <div
          class="TabPanel-title-small-screen"
          [ngClass]="{ 'is-active': state.parentStateIs('tabs.company.balances') }"
        >
          {{ 'ResidualVacation.Balances' | translate }}
        </div>
      </div>

      <!-- Company Approval -->
      <div class="TabPanel-item" [ngClass]="{ 'is-active': state.parentStateIs('tabs.company.approval') }">
        <button
          id="CompanyApprovalTabButton"
          class="TabPanel-link"
          type="button"
          (click)="navigateToStateNonWaitting($event, 'tabs.company.approval')"
          [ngClass]="{ 'is-active': state.parentStateIs('tabs.company.approval') }"
        >
          <div>
            <app-icon [icon]="'CalendarCheck'"></app-icon>
            <div class="TabPanel-title">
              {{ 'CompanySalaryTypes.Approval' | translate }}
            </div>
          </div>
        </button>
        <div
          class="TabPanel-title-small-screen"
          [ngClass]="{ 'is-active': state.parentStateIs('tabs.company.approval') }"
        >
          {{ 'CompanySalaryTypes.Approval' | translate }}
        </div>
      </div>
      <!-- Company Configuration -->
      <div
        class="TabPanel-item"
        *ngIf="!session.role.EmployeeWithRoleAsManager"
        [ngClass]="{ 'is-active': state.parentStateIs('tabs.company.configuration') }"
      >
        <button
          id="CompanyConfigurationTabButton"
          class="TabPanel-link"
          type="button"
          (click)="navigateToStateNonWaitting($event, 'tabs.company.configuration')"
          [ngClass]="{ 'is-active': state.parentStateIs('tabs.company.configuration') }"
        >
          <div>
            <app-icon [icon]="'Cog'"></app-icon>
            <div class="TabPanel-title">
              {{ 'Company.Configuration' | translate }}
            </div>
          </div>
        </button>
        <div
          class="TabPanel-title-small-screen"
          [ngClass]="{ 'is-active': state.parentStateIs('tabs.company.configuration') }"
        >
          {{ 'Company.Configuration' | translate }}
        </div>
      </div>
      <!-- Company Modules -->
      <div
        class="TabPanel-item"
        *ngIf="session.role.IsFullAdmin && !IsGreenlandCompany && !session.role.EmployeeWithRoleAsManager"
        [ngClass]="{ 'is-active': state.currentStateIs('tabs.company.modules') }"
      >
        <button
          id="CompanyModulesTabButton"
          class="TabPanel-link"
          type="button"
          (click)="navigateToStateNonWaitting($event, 'tabs.company.modules')"
          [ngClass]="{ 'is-active': state.currentStateIs('tabs.company.modules') }"
        >
          <div>
            <app-icon [icon]="'Diamond'"></app-icon>
            <div class="TabPanel-title">
              {{ 'Account.Modules' | translate }}
            </div>
          </div>
        </button>
        <div
          class="TabPanel-title-small-screen"
          [ngClass]="{ 'is-active': state.currentStateIs('tabs.company.modules') }"
        >
          {{ 'Account.Modules' | translate }}
        </div>
      </div>
    </ng-container>

    <!-- Self Service tabs -->
    <ng-container *ngIf="parentTab === 'selfService'">
      <!-- Selfservice Payslips -->
      <div
        class="TabPanel-item"
        *ngIf="payslipTabVisible"
        [ngClass]="{ 'is-active': state.currentStateIs('tabs.selfservice.payslip') }"
      >
        <button
          id="SelfServicePayslipsTabButton"
          class="TabPanel-link"
          type="button"
          (click)="navigateToState($event, 'tabs.selfservice.payslip')"
          [ngClass]="{ 'is-active': state.currentStateIs('tabs.selfservice.payslip') }"
        >
          <div>
            <app-icon [icon]="'Dollar'"></app-icon>
            <div class="TabPanel-title">
              {{ 'EmployeeGeneral.Payslips' | translate }}
            </div>
          </div>
        </button>
        <div
          class="TabPanel-title-small-screen"
          [ngClass]="{ 'is-active': state.currentStateIs('tabs.selfservice.payslip') }"
        >
          {{ 'EmployeeGeneral.Payslips' | translate }}
        </div>
      </div>
      <!-- SelfService My Details -->
      <div class="TabPanel-item" [ngClass]="{ 'is-active': state.currentStateIs('tabs.selfservice.general') }">
        <button
          id="SelfServiceGeneralTabButton"
          class="TabPanel-link"
          type="button"
          (click)="navigateToState($event, 'tabs.selfservice.general')"
          [ngClass]="{ 'is-active': state.currentStateIs('tabs.selfservice.general') }"
        >
          <div>
            <app-icon [icon]="'User'"></app-icon>
            <div class="TabPanel-title">
              {{ 'SelfService.MyDetails' | translate }}
            </div>
          </div>
        </button>
        <div
          class="TabPanel-title-small-screen"
          [ngClass]="{ 'is-active': state.currentStateIs('tabs.selfservice.general') }"
        >
          {{ 'SelfService.MyDetails' | translate }}
        </div>
      </div>
      <!-- Selfservice Time -->
      <div
        class="TabPanel-item"
        *ngIf="timeTabVisible"
        [ngClass]="{ 'is-active': state.currentStateIs('tabs.selfservice.time') }"
      >
        <button
          id="SelfServiceTimeTabButton"
          class="TabPanel-link"
          type="button"
          (click)="navigateToState($event, 'tabs.selfservice.time')"
          [ngClass]="{ 'is-active': state.currentStateIs('tabs.selfservice.time') }"
        >
          <div>
            <app-icon [icon]="'Clock'"></app-icon>
            <div class="TabPanel-title">
              {{ 'Employee.Time' | translate }}
            </div>
          </div>
        </button>
        <div
          class="TabPanel-title-small-screen"
          [ngClass]="{ 'is-active': state.currentStateIs('tabs.selfservice.time') }"
        >
          {{ 'Employee.Time' | translate }}
        </div>
      </div>
    </ng-container>

    <!-- Accountant tabs -->
    <ng-container *ngIf="parentTab === 'accountant'">
      <!-- Accountant Companies -->
      <div class="TabPanel-item" [ngClass]="{ 'is-active': state.currentStateIs('tabs.accountant.companies') }">
        <button
          id="AccountantCompaniesTabButton"
          class="TabPanel-link"
          type="button"
          (click)="navigateToState($event, 'tabs.accountant.companies')"
          [ngClass]="{ 'is-active': state.currentStateIs('tabs.accountant.companies') }"
        >
          <div>
            <app-icon [icon]="'Industry'"></app-icon>
            <div class="TabPanel-title">
              {{ 'Accountant.Companies' | translate }}
            </div>
          </div>
        </button>
        <div
          class="TabPanel-title-small-screen"
          [ngClass]="{ 'is-active': state.currentStateIs('tabs.accountant.companies') }"
        >
          {{ 'Accountant.Companies' | translate }}
        </div>
      </div>
      <!-- Accountant Users -->
      <div
        class="TabPanel-item"
        *ngIf="!session.feature.BasicUser"
        [ngClass]="{ 'is-active': state.currentStateIs('tabs.accountant.users') }"
      >
        <button
          id="AccountantUsersTabButton"
          class="TabPanel-link"
          type="button"
          (click)="navigateToState($event, 'tabs.accountant.users')"
          [ngClass]="{ 'is-active': state.currentStateIs('tabs.accountant.users') }"
        >
          <div>
            <app-icon [icon]="'User'"></app-icon>
            <div class="TabPanel-title">
              {{ 'Accountant.Users' | translate }}
            </div>
          </div>
        </button>
        <div
          class="TabPanel-title-small-screen"
          [ngClass]="{ 'is-active': state.currentStateIs('tabs.accountant.users') }"
        >
          {{ 'Accountant.Users' | translate }}
        </div>
      </div>
      <!-- Accountant Configuration -->
      <div
        *ngIf="session.role.IsAccountAdmin"
        class="TabPanel-item"
        [ngClass]="{ 'is-active': state.currentStateIs('tabs.accountant.configuration') }"
      >
        <button
          id="AccountantConfigurationTabButton"
          class="TabPanel-link"
          type="button"
          (click)="navigateToState($event, 'tabs.accountant.configuration')"
          [ngClass]="{ 'is-active': state.currentStateIs('tabs.accountant.configuration') }"
        >
          <div>
            <app-icon [icon]="'Cog'"></app-icon>
            <div class="TabPanel-title">
              {{ 'Accountant.Configuration' | translate }}
            </div>
          </div>
        </button>
        <div
          class="TabPanel-title-small-screen"
          [ngClass]="{ 'is-active': state.currentStateIs('tabs.accountant.configuration') }"
        >
          {{ 'Accountant.Configuration' | translate }}
        </div>
      </div>
    </ng-container>
  </div>

  <!-- Top bar toggle -->
  <div class="Menu-toogle-item">
    <button
      class="TabPanel-link"
      type="button"
      [ngClass]="{ 'is-active': session.menuToggled }"
      (click)="toggleMenuButton()"
    >
      <div>
        <app-icon *ngIf="session.menuToggled" [icon]="'LevelDown'"></app-icon>
        <app-icon *ngIf="!session.menuToggled" [icon]="'LevelUp'"></app-icon>
      </div>
    </button>
  </div>
</div>
